import React, { PureComponent, PropTypes } from 'react'
import Button from '../Button'
import Input from '../Input'
import Text from '../Text'
import Media from '../Media'
import Helper from '../Helper'
import Container from '../Container'
import MessagePreview from '../MessagePreview'
import './index.css'

class Form extends PureComponent {
  state = {
    success: false,
    image: null,
    message: {
      name: null,
      content: null,
      image: null,
    },
    errors: {
      name: false,
      content: false,
      image: false,
    },
  }

  handlePreview = (image) => this.setState({ image })

  handleNameChange = (e) => {
    e.persist()

    this.setState((prevState) => ({
      message: {
        ...prevState.message,
        name: e.target.value,
      },
      errors: {
        ...prevState.errors,
        name: false,
      },
    }))
  }

  handleContentChange = (e) => {
    e.persist()

    this.setState((prevState) => ({
      message: {
        ...prevState.message,
        content: e.target.value,
      },
      errors: {
        ...prevState.errors,
        content: false,
      },
    }))
  }

  handleImageChange = (file) => {
    this.setState((prevState) => ({
      message: {
        ...prevState.message,
        image: file,
      },
      errors: {
        ...prevState.errors,
        image: false,
      },
    }))
  }

  handleSendClick = (e) => {
    e.preventDefault()

    if (this.validate()) {
      const { name, content, image } = this.state.message
      const body = new FormData()

      body.append('name', name)
      body.append('content', content)
      body.append('image', image)

      fetch(`/server/public/create.php`, { method: 'POST', body })
        .then((response) => response.json())
        .then(({ message }) => this.setState({ success: true }))
    }
  }

  validate() {
    const { name, content, image } = this.state.message
    const isNameValid = !this.isEmpty(name)
    const isContentValid = !this.isEmpty(content)
    const isImageValid = image instanceof File
      ? !this.isInvalidImage(image)
      : !this.isEmpty(image)

    this.setState({
      errors: {
        name: !isNameValid,
        content: !isContentValid,
        image: !isImageValid,
      },
    })

    return isNameValid && isContentValid && isImageValid
  }

  isInvalidImage(image) {
    return !(image instanceof File) || image.type !== 'image/gif'
  }

  isEmpty(str) {
    return typeof str !== 'string' || str.trim().length === 0
  }

  render() {
    return (
      <Container
        background={ this.state.image ? `url(${ this.state.image })` : '#000'  }
        backgroundInner={ '#fff' }>
        {
          this.state.success
          ? (
            <div>
              <MessagePreview
                content={ this.state.message.content }
                name={ this.state.message.name } />

              <div className={ 'form-success' }>
                Merci! Ton message a bien été enregistré.
              </div>
            </div>
          )
          : (
            <form>
              <div className={ 'form-group' }>
                <Text
                  className={ 'form-textarea' }
                  placeholder={ 'ton message pour faire pleurer Cath' }
                  onChange={ this.handleContentChange } />
                <Helper show={ this.state.errors.content }>
                  Tu dois entrer ton message.
                </Helper>
              </div>

              <div className={ 'form-group' }>
                <Input
                  className={ 'form-input' }
                  placeholder={ 'ton nom' }
                  onChange={ this.handleNameChange } />
                <Helper show={ this.state.errors.name }>
                  Tu dois entrer ton nom.
                </Helper>
              </div>

              <div className={ 'form-group' }>
                <Media
                  onChange={ this.handleImageChange }
                  onPreview={ this.handlePreview } />
                <Helper show={ this.state.errors.image }>
                  Tu dois ajouter un GIF.
                </Helper>
              </div>

              <div className={ 'form-group' }>
                <Button onClick={ this.handleSendClick }>
                  Envoyer!
                </Button>
              </div>
            </form>
          )
        }
      </Container>
    )
  }
}

Form.contextTypes = {
  router: PropTypes.object,
}

export default Form



// WEBPACK FOOTER //
// ./src/components/Form/index.js